<form nz-form nzLayout="vertical" [formGroup]="serviceNumberConfigForm" class="form-container" [testId]="'service-config-form'">
  <div class="config-page-shell" [class.embedded-detail-mode]="embeddedInDetail" [testId]="'service-config-card'">
    <div class="page-topbar">
      <div class="card-header" [testId]="'service-config-header'">
        <div class="card-heading" [testId]="'service-config-heading'">
          <h3 class="page-title" [testId]="'service-config-page-title'">{{ 'servicenumber.service-setting' | i18n }}</h3>
          <p class="page-subtitle" [testId]="'service-config-page-subtitle'">{{ 'servicenumber.config.page-subtitle' | i18n }}</p>
        </div>
        <div class="card-actions" [testId]="'service-config-actions'">
          <button
            nz-button
            [nzType]="hasUnsavedChanges ? 'primary' : 'default'"
            type="button"
            class="save-button"
            (click)="saveServiceConfig()"
            [nzLoading]="isSaving"
            [disabled]="!hasUnsavedChanges"
            [testId]="'service-config-save-button'"
          >
            <i nz-icon nzType="save" [testId]="'config-save-icon'"></i>{{ 'common.save' | i18n }}
          </button>
        </div>
      </div>

      <div class="draft-banner" *ngIf="hasUnsavedChanges">{{ 'servicenumber.config.unsaved-banner' | i18n }}</div>
    </div>

    <div class="settings-surface">
      <div class="section-block section-panel">
        <div class="section-heading">
          <h3 class="section-title">
            <span class="section-kicker"><i nz-icon nzType="setting" nzTheme="outline"></i></span>
            {{ 'servicenumber.config.service-settings' | i18n }}
          </h3>
        </div>

        <div nz-row [nzGutter]="24">
          <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'timeout-time-col'">
            <nz-form-item class="has-control-hint" [testId]="'timeout-time-form-item'">
              <nz-form-label nzRequired nzFor="timeoutTime">{{ 'servicenumber.config.timeout-time' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'timeout-time-control'">
                <div class="control-hint">{{ 'servicenumber.config.timeout-time-hint' | i18n }}</div>
                <nz-select
                  [testId]="'timeout-time-select'"
                  formControlName="timeoutTime"
                  id="timeoutTime"
                  [nzPlaceHolder]="'servicenumber.config.select-timeout-time' | i18n"
                  nzAllowClear
                >
                  <nz-option
                    *ngFor="let option of timeoutOptions"
                    [nzValue]="option.value"
                    [nzLabel]="getOptionLabel(option)"
                    [testId]="'timeout-option-' + option.value"
                  />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12" *ngIf="canShowExpireTime()" [testId]="'expired-time-col'">
            <nz-form-item class="has-control-hint" [testId]="'expired-time-form-item'">
              <nz-form-label nzFor="expireTime">{{ 'servicenumber.config.expired-time' | i18n }}</nz-form-label>
              <nz-form-control [nzErrorTip]="expireTimeErrorTpl" [testId]="'expired-time-control'">
                <div class="control-hint">{{ 'servicenumber.config.expired-time-hint' | i18n }}</div>
                <nz-date-picker
                  [testId]="'expired-time-picker'"
                  formControlName="expireTime"
                  id="expireTime"
                  nzFormat="yyyy-MM-dd"
                  [nzPlaceHolder]="'servicenumber.config.select-expired-date' | i18n"
                  [nzDisabledDate]="disablePastDates"
                  nzAllowClear
                  style="width: 100%"
                />
                <ng-template #expireTimeErrorTpl>
                  <span>{{ 'servicenumber.config.expired-time-must-be-future' | i18n }}</span>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12" *ngIf="isBossType()" [testId]="'auto-transfer-time-col'">
            <nz-form-item class="has-control-hint" [testId]="'auto-transfer-time-form-item'">
              <nz-form-label nzFor="ownerAutoTransferTime">{{ 'servicenumber.config.auto-transfer-time' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'auto-transfer-time-control'">
                <div class="control-hint">{{ 'servicenumber.config.auto-transfer-time-hint' | i18n }}</div>
                <div
                  *ngIf="loading; else autoTransferTimeInput"
                  class="control-loading-placeholder"
                  [testId]="'auto-transfer-time-loading'"
                ></div>
                <ng-template #autoTransferTimeInput>
                  <nz-input-number
                    [testId]="'auto-transfer-time-input'"
                    formControlName="ownerAutoTransferTime"
                    id="ownerAutoTransferTime"
                    [nzPlaceHolder]="'servicenumber.config.enter-transfer-time' | i18n"
                    [nzMin]="0"
                    [nzMax]="999999"
                    style="width: 100%"
                  />
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="section-panel">
        <div class="section-heading">
          <h3 [testId]="'work-time-settings-title'">
            <span class="section-kicker"><i nz-icon nzType="clock-circle" nzTheme="outline"></i></span>
            {{ 'servicenumber.config.work-time-settings' | i18n }}
          </h3>
        </div>
        <div nz-row [nzGutter]="24" [testId]="'work-time-row'">
          <div nz-col [nzXs]="24" [nzSm]="24" [testId]="'work-time-col'">
            <nz-form-item class="has-control-hint" [testId]="'work-time-form-item'">
              <nz-form-label nzRequired>{{ 'servicenumber.config.work-time' | i18n }}</nz-form-label>
              <nz-form-control>
                <div class="control-hint">{{ 'servicenumber.config.work-time-hint' | i18n }}</div>
                <div class="work-time-display-control">
                  <input
                    nz-input
                    formControlName="workTime"
                    readonly
                    [attr.aria-label]="'servicenumber.config.work-time' | i18n"
                    [testId]="'work-time-display'"
                  />
                  <button
                    nz-button
                    nzType="default"
                    type="button"
                    class="work-time-edit-button"
                    (click)="openWorkTimeModal()"
                    [testId]="'work-time-edit-button'"
                  >
                    <i nz-icon nzType="edit" nzTheme="outline"></i>{{ 'servicenumber.config.work-time-edit' | i18n }}
                  </button>
                </div>
                <div *ngIf="getWorkTimeValidationMessageKey() as errorKey" class="work-time-error" [testId]="'work-time-error'">
                  {{ errorKey | i18n }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="24" [testId]="'non-work-time-col'">
            <nz-form-item class="textarea-item has-control-hint" [testId]="'non-work-time-form-item'">
              <nz-form-label nzRequired nzFor="nonWorkTimeGreetings">{{
                'servicenumber.config.non-work-time-response' | i18n
              }}</nz-form-label>
              <nz-form-control>
                <div class="control-hint">{{ 'servicenumber.config.non-work-time-hint' | i18n }}</div>
                <textarea
                  [testId]="'non-work-time-textarea'"
                  nz-input
                  formControlName="nonWorkTimeGreetings"
                  id="nonWorkTimeGreetings"
                  [placeholder]="'servicenumber.config.enter-non-work-time-greeting' | i18n"
                  [nzAutosize]="{ minRows: 2, maxRows: 3 }"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="section-panel">
        <div class="section-heading">
          <h3 [testId]="'greeting-settings-title'">
            <span class="section-kicker"><i nz-icon nzType="message" nzTheme="outline"></i></span>
            {{ 'servicenumber.config.greeting-settings' | i18n }}
          </h3>
        </div>
        <div nz-row [nzGutter]="24" [testId]="'greeting-row'">
          <div nz-col [nzXs]="24" [nzSm]="24" [testId]="'first-greeting-col'">
            <nz-form-item class="textarea-item has-control-hint" [testId]="'first-greeting-form-item'">
              <nz-form-label nzFor="firstGreetings">{{ 'servicenumber.config.first-greeting' | i18n }}</nz-form-label>
              <nz-form-control>
                <div class="control-hint">{{ 'servicenumber.config.first-greeting-hint' | i18n }}</div>
                <textarea
                  nz-input
                  [testId]="'first-greeting-textarea'"
                  formControlName="firstGreetings"
                  id="firstGreetings"
                  [placeholder]="'servicenumber.config.enter-first-greeting' | i18n"
                  [nzAutosize]="{ minRows: 2, maxRows: 3 }"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="24" [testId]="'every-greeting-col'">
            <nz-form-item class="textarea-item has-control-hint" [testId]="'every-greeting-form-item'">
              <nz-form-label nzFor="everyGreetings">{{ 'servicenumber.config.every-greeting' | i18n }}</nz-form-label>
              <nz-form-control>
                <div class="control-hint">{{ 'servicenumber.config.every-greeting-hint' | i18n }}</div>
                <textarea
                  nz-input
                  [testId]="'every-greeting-textarea'"
                  formControlName="everyGreetings"
                  id="everyGreetings"
                  [placeholder]="'servicenumber.config.enter-every-greeting' | i18n"
                  [nzAutosize]="{ minRows: 2, maxRows: 3 }"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="24" [testId]="'robot-greeting-col'">
            <nz-form-item class="has-control-hint" [testId]="'robot-greeting-switch-form-item'">
              <nz-form-label nzFor="useGreetingQuestion">{{ 'servicenumber.config.enable-ai-fixed-greeting' | i18n }}</nz-form-label>
              <nz-form-control>
                <div class="control-hint" [testId]="'robot-greeting-switch-hint'">
                  {{ 'servicenumber.config.enable-ai-fixed-greeting-hint' | i18n }}
                </div>
                <nz-switch formControlName="useGreetingQuestion" id="useGreetingQuestion" [testId]="'robot-greeting-switch'" />
              </nz-form-control>
            </nz-form-item>

            <nz-form-item
              *ngIf="serviceNumberConfigForm.get('useGreetingQuestion')?.value"
              class="textarea-item has-control-hint"
              [testId]="'robot-greeting-form-item'"
            >
              <nz-form-label [nzRequired]="isRobotEnabled()" nzFor="greetingQuestionText">
                {{ 'servicenumber.config.ai-fixed-greeting' | i18n }}
              </nz-form-label>
              <nz-form-control>
                <div class="control-hint" [testId]="'robot-greeting-hint'">{{ 'servicenumber.config.ai-fixed-greeting-hint' | i18n }}</div>
                <textarea
                  nz-input
                  [testId]="'robot-greeting-textarea'"
                  formControlName="greetingQuestionText"
                  id="greetingQuestionText"
                  [placeholder]="'servicenumber.config.enter-ai-fixed-greeting' | i18n"
                  [nzAutosize]="{ minRows: 2, maxRows: 3 }"
                  [attr.maxlength]="greetingQuestionMaxLength"
                ></textarea>
                <div class="field-meta" [testId]="'robot-greeting-meta'">
                  {{ (serviceNumberConfigForm.get('greetingQuestionText')?.value || '').length }}/{{ greetingQuestionMaxLength }}
                </div>
                <div
                  class="field-error"
                  *ngIf="
                    serviceNumberConfigForm.get('greetingQuestionText')?.invalid &&
                    (serviceNumberConfigForm.get('greetingQuestionText')?.dirty ||
                      serviceNumberConfigForm.get('greetingQuestionText')?.touched)
                  "
                  [testId]="'robot-greeting-error'"
                >
                  {{ getGreetingQuestionErrorKey() | i18n }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="24" [testId]="'handover-reply-col'">
            <nz-form-item class="has-control-hint" [testId]="'handover-reply-switch-form-item'">
              <nz-form-label nzFor="useHandOverTextReply">{{ 'servicenumber.config.enable-handover-confirmation' | i18n }}</nz-form-label>
              <nz-form-control>
                <div class="control-hint" [testId]="'handover-reply-switch-hint'">
                  {{ 'servicenumber.config.enable-handover-confirmation-hint' | i18n }}
                </div>
                <nz-switch formControlName="useHandOverTextReply" id="useHandOverTextReply" [testId]="'handover-reply-switch'" />
              </nz-form-control>
            </nz-form-item>

            <nz-form-item
              *ngIf="serviceNumberConfigForm.get('useHandOverTextReply')?.value"
              class="textarea-item has-control-hint"
              [testId]="'handover-reply-form-item'"
            >
              <nz-form-label [nzRequired]="isRobotEnabled()" nzFor="handOverTextReplyText">
                {{ 'servicenumber.config.handover-confirmation' | i18n }}
              </nz-form-label>
              <nz-form-control>
                <div class="control-hint" [testId]="'handover-reply-hint'">{{
                  'servicenumber.config.handover-confirmation-hint' | i18n
                }}</div>
                <textarea
                  nz-input
                  [testId]="'handover-reply-textarea'"
                  formControlName="handOverTextReplyText"
                  id="handOverTextReplyText"
                  [placeholder]="'servicenumber.config.enter-handover-confirmation' | i18n"
                  [nzAutosize]="{ minRows: 2, maxRows: 3 }"
                ></textarea>
                <div
                  class="field-error"
                  *ngIf="
                    serviceNumberConfigForm.get('handOverTextReplyText')?.invalid &&
                    (serviceNumberConfigForm.get('handOverTextReplyText')?.dirty ||
                      serviceNumberConfigForm.get('handOverTextReplyText')?.touched)
                  "
                  [testId]="'handover-reply-error'"
                >
                  {{ 'servicenumber.config.enter-handover-confirmation' | i18n }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item class="has-control-hint">
              <nz-form-label nzRequired nzFor="idleTime">{{ 'servicenumber.config.idle-time' | i18n }}</nz-form-label>
              <nz-form-control>
                <div class="control-hint">{{ 'servicenumber.config.idle-time-hint' | i18n }}</div>
                <nz-select
                  formControlName="idleTime"
                  id="idleTime"
                  [nzPlaceHolder]="'servicenumber.config.select-idle-time' | i18n"
                  nzAllowClear
                  testId="servicenumber-config-idle-time-select"
                >
                  <nz-option
                    *ngFor="let option of idleTimeOptions"
                    [nzValue]="option.value"
                    [nzLabel]="getOptionLabel(option)"
                    [testId]="'idle-time-option-' + option.value"
                  />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="24">
            <nz-form-item class="textarea-item has-control-hint">
              <nz-form-label nzFor="idleGreetings">{{ 'servicenumber.config.idle-greeting' | i18n }}</nz-form-label>
              <nz-form-control>
                <div class="control-hint">{{ 'servicenumber.config.idle-greeting-hint' | i18n }}</div>
                <textarea
                  nz-input
                  formControlName="idleGreetings"
                  id="idleGreetings"
                  [placeholder]="'servicenumber.config.enter-idle-greeting' | i18n"
                  [nzAutosize]="{ minRows: 2, maxRows: 3 }"
                  testId="servicenumber-config-idle-greetings-textarea"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="section-panel">
        <div class="section-heading">
          <h3 [testId]="'satisfaction-settings-title'">
            <span class="section-kicker"><i nz-icon nzType="smile" nzTheme="outline"></i></span>
            {{ 'servicenumber.config.satisfaction-settings' | i18n }}
          </h3>
        </div>
        <div nz-row [nzGutter]="24" [testId]="'satisfaction-switches-row'">
          <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'use-satisfaction-col'">
            <nz-form-item class="has-control-hint" [testId]="'use-satisfaction-form-item'">
              <nz-form-label nzFor="useSatisfactionSurvey">{{ 'servicenumber.config.use-satisfaction-survey' | i18n }}</nz-form-label>
              <nz-form-control>
                <div class="control-hint">{{ 'servicenumber.config.satisfaction-hint' | i18n }}</div>
                <nz-switch formControlName="useSatisfactionSurvey" id="useSatisfactionSurvey" [testId]="'use-satisfaction-switch'" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div
          *ngIf="serviceNumberConfigForm.get('useSatisfactionSurvey')?.value"
          class="satisfaction-detail-panel"
          [testId]="'satisfaction-enabled-block'"
        >
          <div nz-row [nzGutter]="24">
            <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'survey-type-col'">
              <nz-form-item class="has-control-hint" [testId]="'survey-type-form-item'">
                <nz-form-label nzRequired nzFor="surveyType">{{ 'servicenumber.config.survey-type' | i18n }}</nz-form-label>
                <nz-form-control>
                  <div class="control-hint">{{ 'servicenumber.config.survey-type-hint' | i18n }}</div>
                  <nz-select
                    formControlName="surveyType"
                    id="surveyType"
                    [nzPlaceHolder]="'servicenumber.config.select-survey-type' | i18n"
                    [testId]="'survey-type-select'"
                    nzAllowClear
                  >
                    <nz-option
                      *ngFor="let opt of surveyTypeOptions"
                      [nzValue]="opt.value"
                      [nzLabel]="opt.label | i18n"
                      [testId]="'survey-type-option-' + opt.value"
                    />
                  </nz-select>
                  <div *ngIf="selectedSurveyTypeDescription" class="control-hint" [testId]="'survey-type-hint'">
                    {{ selectedSurveyTypeDescription | i18n }}
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'survey-rate-col'">
              <nz-form-item class="has-control-hint" [testId]="'survey-rate-form-item'">
                <nz-form-label nzRequired nzFor="surveyRate">{{ 'servicenumber.config.survey-rate' | i18n }}</nz-form-label>
                <nz-form-control>
                  <div class="control-hint">{{ 'servicenumber.config.survey-rate-hint' | i18n }}</div>
                  <nz-input-number
                    formControlName="surveyRate"
                    id="surveyRate"
                    [testId]="'survey-rate-input'"
                    [nzMin]="0"
                    [nzMax]="100"
                    [nzStep]="1"
                    style="width: 100%"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'use-notice-col'">
              <nz-form-item class="has-control-hint" [testId]="'use-notice-form-item'">
                <nz-form-label nzFor="useSatisfactionSurveyNotice">{{
                  'servicenumber.config.use-satisfaction-notice' | i18n
                }}</nz-form-label>
                <nz-form-control>
                  <div class="control-hint">{{ 'servicenumber.config.use-satisfaction-notice-hint' | i18n }}</div>
                  <nz-switch
                    formControlName="useSatisfactionSurveyNotice"
                    id="useSatisfactionSurveyNotice"
                    [testId]="'use-notice-switch'"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div
            *ngIf="serviceNumberConfigForm.get('useSatisfactionSurveyNotice')?.value"
            class="satisfaction-notice-panel"
            [testId]="'notice-enabled-block'"
          >
            <div nz-row [nzGutter]="24">
              <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'notice-type-col'">
                <nz-form-item class="has-control-hint" [testId]="'notice-type-form-item'">
                  <nz-form-label nzRequired nzFor="noticeType">{{ 'servicenumber.config.notice-type' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <div class="control-hint">{{ 'servicenumber.config.notice-type-hint' | i18n }}</div>
                    <nz-select
                      formControlName="noticeType"
                      id="noticeType"
                      [testId]="'notice-type-select'"
                      nzMode="multiple"
                      nzAllowClear
                      [nzPlaceHolder]="'servicenumber.config.select-notice-type' | i18n"
                    >
                      <nz-option
                        *ngFor="let opt of noticeTypeOptions"
                        [nzValue]="opt.value"
                        [nzLabel]="opt.label | i18n"
                        [testId]="'notice-type-option-' + opt.value"
                      />
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'notice-email-col'">
                <nz-form-item class="has-control-hint" [testId]="'notice-email-form-item'">
                  <nz-form-label nzFor="noticeEmail">{{ 'servicenumber.config.notice-email' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <div class="control-hint">{{ 'servicenumber.config.notice-email-hint' | i18n }}</div>
                    <input nz-input formControlName="noticeEmail" id="noticeEmail" [testId]="'notice-email-input'" />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'notice-sms-col'">
                <nz-form-item class="has-control-hint" [testId]="'notice-sms-form-item'">
                  <nz-form-label nzFor="noticeSms">{{ 'servicenumber.config.notice-sms' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <div class="control-hint">{{ 'servicenumber.config.notice-sms-hint' | i18n }}</div>
                    <input nz-input formControlName="noticeSms" id="noticeSms" [testId]="'notice-sms-input'" />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-panel">
        <div class="section-heading">
          <h3 [testId]="'voice-to-text-settings-title'">
            <span class="section-kicker"><i nz-icon nzType="audio" nzTheme="outline"></i></span>
            {{ 'servicenumber.config.voice-to-text-settings' | i18n }}
          </h3>
        </div>
        <div nz-row [nzGutter]="24">
          <div nz-col [nzXs]="24" [nzSm]="8" [testId]="'voice-to-text-col'">
            <nz-form-item class="has-control-hint" [testId]="'voice-to-text-form-item'">
              <nz-form-label nzFor="useVoiceToText">{{ 'servicenumber.config.enable-voice-to-text' | i18n }}</nz-form-label>
              <nz-form-control>
                <div class="control-hint">{{ 'servicenumber.config.enable-voice-to-text-hint' | i18n }}</div>
                <nz-switch formControlName="useVoiceToText" id="useVoiceToText" testId="servicenumber-config-use-voice-to-text-switch" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div *ngIf="serviceNumberConfigForm.get('useVoiceToText')?.value" [testId]="'voice-to-text-enabled-block'">
          <nz-form-item class="textarea-item has-control-hint" [testId]="'voice-to-text-json-form-item'">
            <nz-form-label nzRequired nzFor="voiceToTextJson">{{ 'servicenumber.config.voice-to-text-config' | i18n }}</nz-form-label>
            <nz-form-control>
              <div class="control-hint">{{ 'servicenumber.config.voice-to-text-hint' | i18n }}</div>
              <textarea
                nz-input
                formControlName="voiceToTextJson"
                id="voiceToTextJson"
                [placeholder]="'servicenumber.config.enter-voice-to-text-json' | i18n"
                testId="servicenumber-config-voice-to-text-json-textarea"
                [nzAutosize]="{ minRows: 2, maxRows: 4 }"
              ></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>
  </div>
</form>

<nz-modal
  *ngIf="workTimeModalVisible"
  [nzClassName]="'work-time-editor-modal'"
  [nzVisible]="workTimeModalVisible"
  [nzTitle]="'servicenumber.config.work-time-modal-title' | i18n"
  [nzWidth]="760"
  [nzMaskClosable]="false"
  [nzFooter]="workTimeModalFooter"
  (nzOnCancel)="closeWorkTimeModal()"
  [testId]="'work-time-modal'"
>
  <ng-container *nzModalContent>
    <p class="work-time-modal-intro">{{ 'servicenumber.config.work-time-modal-intro' | i18n }}</p>
    <div class="work-time-range-list" [testId]="'work-time-range-list'">
      <div
        *ngFor="let range of workTimeRanges.controls; let index = index"
        class="work-time-range-row"
        [formGroup]="range"
        [testId]="'work-time-range-row-' + index"
      >
        <span class="work-time-range-index">{{ index + 1 }}</span>
        <nz-select
          formControlName="startHour"
          class="work-time-select work-time-hour-select"
          [nzPlaceHolder]="'servicenumber.config.work-time-start-hour' | i18n"
          [attr.aria-label]="'servicenumber.config.work-time-start-hour' | i18n"
          [testId]="'work-time-start-hour-select-' + index"
        >
          <nz-option *ngFor="let option of workTimeHourOptions" [nzValue]="option.value" [nzLabel]="option.label" />
        </nz-select>
        <span class="work-time-colon" aria-hidden="true">:</span>
        <nz-select
          formControlName="startMinute"
          class="work-time-select work-time-minute-select"
          [nzPlaceHolder]="'servicenumber.config.work-time-start-minute' | i18n"
          [attr.aria-label]="'servicenumber.config.work-time-start-minute' | i18n"
          [testId]="'work-time-start-minute-select-' + index"
        >
          <nz-option *ngFor="let option of workTimeMinuteOptions" [nzValue]="option.value" [nzLabel]="option.label" />
        </nz-select>
        <span class="work-time-range-separator" aria-hidden="true">-</span>
        <nz-select
          formControlName="endHour"
          class="work-time-select work-time-hour-select"
          [nzPlaceHolder]="'servicenumber.config.work-time-end-hour' | i18n"
          [attr.aria-label]="'servicenumber.config.work-time-end-hour' | i18n"
          [testId]="'work-time-end-hour-select-' + index"
        >
          <nz-option *ngFor="let option of workTimeEndHourOptions" [nzValue]="option.value" [nzLabel]="option.label" />
        </nz-select>
        <span class="work-time-colon" aria-hidden="true">:</span>
        <nz-select
          formControlName="endMinute"
          class="work-time-select work-time-minute-select"
          [nzPlaceHolder]="'servicenumber.config.work-time-end-minute' | i18n"
          [attr.aria-label]="'servicenumber.config.work-time-end-minute' | i18n"
          [testId]="'work-time-end-minute-select-' + index"
        >
          <nz-option *ngFor="let option of getEndMinuteOptions(index)" [nzValue]="option.value" [nzLabel]="option.label" />
        </nz-select>
        <button
          nz-button
          nzType="text"
          nzDanger
          nzSize="small"
          nzShape="circle"
          type="button"
          class="work-time-remove-button"
          [attr.aria-label]="'servicenumber.config.work-time-remove-range' | i18n"
          [nz-tooltip]="'servicenumber.config.work-time-remove-range' | i18n"
          (click)="removeWorkTimeRange(index)"
          [testId]="'work-time-remove-range-button-' + index"
        >
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </button>
      </div>
    </div>
    <button
      nz-button
      nzType="dashed"
      nzShape="round"
      type="button"
      class="work-time-add-button"
      (click)="addWorkTimeRange()"
      [testId]="'work-time-add-range-button'"
    >
      <i nz-icon nzType="plus"></i>{{ 'servicenumber.config.work-time-add-range' | i18n }}
    </button>
    <div class="control-hint">{{ 'servicenumber.config.work-time-format-hint' | i18n }}</div>
    <div *ngIf="getWorkTimeValidationMessageKey() as errorKey" class="work-time-error" [testId]="'work-time-error'">
      {{ errorKey | i18n }}
    </div>
  </ng-container>
  <ng-template #workTimeModalFooter>
    <button nz-button nzShape="round" type="button" (click)="closeWorkTimeModal()" [testId]="'work-time-cancel-button'">{{
      'common.cancel' | i18n
    }}</button>
    <button
      nz-button
      nzType="primary"
      nzShape="round"
      type="button"
      [disabled]="isWorkTimeModalConfirmDisabled()"
      (click)="confirmWorkTimeModal()"
      [testId]="'work-time-confirm-button'"
    >
      {{ 'common.confirm' | i18n }}
    </button>
  </ng-template>
</nz-modal>
